import { useRef, useState } from "react";
import { Button } from "@akin2unde/flowui-react";
import { apiClient } from "../api/ApiClient";
import { errorMessage } from "../utils/ErrorMessage";
export default function PostStockButton({kind,code,onPosted}: {kind:"count"|"transfer";code:string;onPosted:()=>void}) {
 const [busy,setBusy]=useState(false),[error,setError]=useState("");const lock=useRef(false);
 async function post() {
  if(lock.current||!window.confirm(kind==="count"?"Post this count to reconcile stock? The count will be locked after posting.":"Post this transfer to move approved quantities from the source to the destination? The transfer will be locked."))return;
  lock.current=true;setBusy(true);setError("");
  try {const entity=kind==="count"?"InventoryCount":"InventoryTransfer";await apiClient.post(`inventory-${kind}/Post${entity}/${encodeURIComponent(code)}`);onPosted();}
  catch(e){setError(errorMessage(e,"Posting failed. Reload and review the record before trying again."));}
  finally{lock.current=false;setBusy(false);}
 }
 return <span><Button variant="outline" disabled={busy} onClick={()=>void post()}>{busy?"Posting…":"Post to stock"}</Button>{error&&<small role="alert">{error}</small>}</span>;
}
